var allCities = [
    {
      "Departamento": "Antioquia",
      "CodeZip": "ANT",
      "Municipio": ["Medellín","Rionegro", "Bello", "Itaguí", "Envigado","Sabaneta","La Estrella"]
    },
    {
      "Departamento": "Bogotá, D.C.",
      "CodeZip": "DC",
      "Municipio": ["Bogotá"]
    },
    {
      "Departamento": "Santander",
      "CodeZip": "SAN",
      "Municipio": ["Bucaramanga"]
    }
  ]
  